import { render } from "./PreviewSubList.vue?vue&type=template&id=48524f77"
import script from "./PreviewSubList.vue?vue&type=script&lang=js"
export * from "./PreviewSubList.vue?vue&type=script&lang=js"

import "./PreviewSubList.vue?vue&type=style&index=0&id=48524f77&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__